import React, { useState } from "react";
import { Popover, FormControlLabel, Checkbox, Tooltip } from "@mui/material";
import { IoMdArrowDropup ,IoMdArrowDropdown  } from "react-icons/io";

const TailoringTypeDropdown = ({ item, selectedTypes = [], onChange, options }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const isOpen = Boolean(anchorEl);

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleToggle = (type) => {
    const newTypes = selectedTypes.includes(type)
      ? selectedTypes.filter((t) => t !== type)
      : [...selectedTypes, type];
    onChange(newTypes);
  };

  // Comma-separated display for button
  const selectedText = selectedTypes.join(", ");

  return (
    <>
      <Tooltip title={selectedText || ""}>
        <button
          onClick={handleOpen}
          className="flex items-center justify-between gap-1 border border-[#D8DAE5] w-[200px] truncate font-[500] rounded-[10px] px-2 py-2 text-sm text-[#3383B2] hover:bg-gray-50 transition"
          style={{ whiteSpace: "nowrap" }}
   
           >
               <span
            className="mx-1 overflow-hidden overflow-ellipsis truncate"
            style={{ width: "180px", fontWeight:500 ,color: selectedTypes.length > 0 ? "#333333" : "#9CA3AF" }}
          >
            {selectedText || "Tailoring types"}
          </span>
          {isOpen ? (
            <IoMdArrowDropup className="text-[20px] text-[#767777]" />
          ) : (
            <IoMdArrowDropdown  className="text-[20px] text-[#767777]" />
          )}
        </button>
      </Tooltip>

      {/* Popover with scrollable options */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <div
          className="p-3 max-w-[200px]"
          style={{
            maxHeight: "150px", // Fixed height
            overflowY: "auto",  // Scroll when overflow
            paddingRight: "4px"
          }}
        >
          <div className="flex flex-col gap-1 w-[180px]">
            {options.map((type) => (
              <FormControlLabel
                key={type}
                control={
                  <Checkbox
                    size="small"
                    checked={selectedTypes.includes(type)}
                    onChange={() => handleToggle(type)}
                    sx={{
                      color: "#3383B2",
                      "&.Mui-checked": { color: "#3383B2" }
                    }}
                  />
                }
                label={<span className="text-xs">{type}</span>}
              />
            ))}
          </div>
        </div>
      </Popover>
    </>
  );
};

export default TailoringTypeDropdown;
